import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { useEditorStore } from "../../store/editorStore";
import { floorplannerStore } from "../../store/floorplannerStore";
import { renderStore } from "../../store/renderStore";

const HINT_DELAY_MS = 200;

/**
 * Bottom hint while dragging a wall (handle or translate).
 * Yellow chip matching WallConstructionEscHint — Shift disables edge snap.
 */
const WallDragShiftHint: React.FC = observer(() => {
  const { t } = useTranslation();
  const editorStore = useEditorStore();
  const [delayElapsed, setDelayElapsed] = useState(false);

  const isWallHandleDrag = floorplannerStore.isDragInProgress();
  const isWallTranslate =
    renderStore.isDragging && renderStore.translatingWallIds.size > 0;
  const dragActive =
    (isWallHandleDrag || isWallTranslate) &&
    floorplannerStore.wallsMap.size > 1 &&
    !editorStore.wallConstructionMode &&
    !editorStore.view3D;

  useEffect(() => {
    if (!dragActive) {
      setDelayElapsed(false);
      return;
    }
    const timer = window.setTimeout(() => setDelayElapsed(true), HINT_DELAY_MS);
    return () => window.clearTimeout(timer);
  }, [dragActive]);

  if (!dragActive || !delayElapsed || editorStore.isShiftPressed) {
    return null;
  }

  return (
    <div
      className="pointer-events-none absolute bottom-8 left-1/2 z-[9997] max-w-xl -translate-x-1/2"
      role="status"
      aria-live="polite"
    >
      <div className="rounded-lg border border-black/15 bg-boniYellowPrimary px-5 py-3 text-sm font-semibold text-black shadow-md">
        <span>
          {t("construction.press")}{" "}
          <kbd className="rounded border border-black/25 bg-white px-2 py-1 font-mono text-xs font-bold leading-none text-black shadow-sm">
            {t("construction.shift")}
          </kbd>{" "}
          {t("construction.wallDragShiftHint")}
        </span>
      </div>
    </div>
  );
});

export default WallDragShiftHint;
